import { useRef, useEffect } from 'react';

export const useRefInjection = (selector: string) => {
  const isIdSelector = selector.startsWith('#');
  const cleanedSelector = isIdSelector ? selector.slice(1) : selector;

  const elementRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const updateRef = () => {
      const element = isIdSelector
        ? document.getElementById(cleanedSelector)
        : document.querySelector(cleanedSelector);

      if (element) {
        elementRef.current = element as HTMLElement;
      }
    };

    updateRef();

    const observer = new MutationObserver(updateRef);
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [cleanedSelector, isIdSelector]);

  return elementRef;
};
